module.exports = __webpack_public_path__ + "img/logo_indomaret.0059aac6.png";